<template>
  <div>
    <!-- 查询条件 -->
    <el-row :gutter="20" style="margin-bottom: 20px">
      <el-col :span="6">
        <el-select
            v-model="searchForm.orgName"
            placeholder="选择机构名称"
            clearable
        >
          <el-option
              v-for="item in organizationNames"
              :key="item"
              :label="item"
              :value="item"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-select
            v-model="searchForm.orgType"
            placeholder="选择机构类型"
            clearable
        >
          <el-option
              v-for="type in organizationTypes"
              :key="type.id"
              :label="type.typeName"
              :value="type.id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align: right">
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button type="primary" @click="showAddDialog">新增机构</el-button>
      </el-col>
    </el-row>

    <!-- 机构信息表格 -->
    <el-table :data="organizations" style="width: 100%" stripe>
      <el-table-column label="机构名称" prop="orgName"></el-table-column>
      <el-table-column label="机构类型" prop="orgType"></el-table-column>
      <el-table-column label="培训周期" prop="trainingCycle" width="120">
        <template #default="{ row }">
          {{ row.trainingCycle ? `${row.trainingCycle} 天` : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="地址" prop="address"></el-table-column>
      <el-table-column label="联系人" prop="contactPerson"></el-table-column>
      <el-table-column label="联系电话" prop="contactPhone"></el-table-column>
      <el-table-column label="邮箱" prop="email"></el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="{ row }">
          <el-button type="text" @click="showEditDialog(row)">编辑</el-button>
          <el-button type="text" @click="deleteOrganization(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        v-if="total > 0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next, jumper"
        @current-change="handlePageChange"
    ></el-pagination>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" title="机构信息">
      <el-form :model="organizationForm" label-width="100px" ref="organizationFormRef">
        <el-form-item label="机构名称" prop="orgName">
          <el-input v-model="organizationForm.orgName" placeholder="请输入机构名称" />
        </el-form-item>
        <el-form-item label="机构类型" prop="orgType">
          <el-select v-model="organizationForm.orgType" placeholder="选择机构类型">
            <el-option
                v-for="type in organizationTypes"
                :key="type.id"
                :label="type.typeName"
                :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训周期" prop="trainingCycle">
          <el-input-number
              v-model="organizationForm.trainingCycle"
              placeholder="培训周期"
          />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="organizationForm.address" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input
              v-model="organizationForm.contactPerson"
              placeholder="请输入联系人姓名"
          />
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
              v-model="organizationForm.contactPhone"
              placeholder="请输入联系电话"
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="organizationForm.email" placeholder="请输入邮箱" />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveOrganization">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      searchForm: {
        orgName: "",
        orgType: "",
      },
      organizations: [],
      organizationForm: {
        id: null,
        orgName: "",
        orgType: "",
        trainingCycle: null,
        address: "",
        contactPerson: "",
        contactPhone: "",
        email: "",
      },
      organizationNames: [], // 下拉框机构名称
      organizationTypes: ["类型A", "类型B", "类型C"], // 机构类型
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      isEdit: false, // 判断是新增还是编辑
    };
  },
  methods: {
    fetchData() {
      const params = {
        orgName: this.searchForm.orgName,
        orgType: this.searchForm.orgType,
        page: this.currentPage,
        size: this.pageSize,
      };

      axios
          .get("/organization/list", { params })
          .then((response) => {
            if (response.data.success) {
              this.organizations = response.data.data;
              this.total = response.data.total;
            } else {
              ElMessage.error(response.data.errorMsg || "加载失败");
            }
          })
          .catch(() => {
            ElMessage.error("服务器异常，加载失败");
          });
    },
    fetchOrganizationNames() {
      axios
          .get("/organization/names")
          .then((response) => {
            if (response.data.success) {
              this.organizationNames = response.data.data;
            }
          })
          .catch(() => {
            ElMessage.error("加载机构名称失败");
          });
    },  fetchOrganizationTypes() {
      axios
          .get("/organization/types")
          .then((response) => {
            if (response.data.success) {
              this.organizationTypes = response.data.data;
            }
            else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch(() => {
            ElMessage.error("加载机构名称失败");
          });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    showAddDialog() {
      this.isEdit = false;
      this.resetOrganizationForm();
      this.dialogVisible = true;
    },
    showEditDialog(row) {
      this.isEdit = true;
      this.organizationForm = { ...row };
      this.dialogVisible = true;
    },
    saveOrganization() {
      const url = this.isEdit
          ? "/organization/update"
          : "/organization/create";
      axios
          .post(url, this.organizationForm)
          .then((response) => {
            if (response.data.success) {
              ElMessage.success(this.isEdit ? "更新成功" : "新增成功");
              this.fetchData();
              this.dialogVisible = false;
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch(() => {
            ElMessage.error("操作失败");
          });
    },
    deleteOrganization(row) {
      axios
          .delete(`/organization/delete/${row.organizationID}`)
          .then((response) => {
            if (response.data.success) {
              ElMessage.success("删除成功");
              this.fetchData();
            } else {
              ElMessage.error(response.data.errorMsg);
            }
          })
          .catch(() => {
            ElMessage.error("删除失败");
          });
    },
    resetOrganizationForm() {
      this.organizationForm = {
        id: null,
        orgName: "",
        orgType: "",
        trainingCycle: null,
        address: "",
        contactPerson: "",
        contactPhone: "",
        email: "",
      };
    },
  },
  created() {
    this.fetchData();
    this.fetchOrganizationNames();
    this.fetchOrganizationTypes();
  },
};
</script>
